import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { GiveawayTabEnum } from '../../../config'
import { GTabText } from '../../UI/Typography'
import { TAB_STYLES } from './constants'
import { TabButtonProps } from './types'

export const TabButton: FC<TabButtonProps> = ({ tab, isSingleTab, activeTab, isActive, onTabClick }) => {
  const isActiveInMode = isSingleTab && activeTab === tab.type
  const isDetailsDisabled = tab.type === GiveawayTabEnum.Details && !isActive

  return (
    <Tab
      key={tab.title}
      disabled={isDetailsDisabled}
      onClick={
        isSingleTab
          ? (e: React.MouseEvent) => {
              e.preventDefault()
              onTabClick(tab)
            }
          : undefined
      }
      className={classNames(
        isSingleTab ? TAB_STYLES.base : TAB_STYLES.multi,
        isActiveInMode && TAB_STYLES.active,
        isDetailsDisabled && TAB_STYLES.disabled,
      )}
    >
      <GTabText>{tab.title}</GTabText>
    </Tab>
  )
}
